import React from 'react';
import PropTypes from 'prop-types';
import css from '../DetailsTab.scss';
import AppointmentPreferences from './AppointmentPreferences';
import { getWord } from 'utils/tenant';
import EmailPreferences from '../EmailPreferences';
import TextPreferences from '../TextPreferences';

/**
 * @returns {node} the Notifications tab of the student's profile.
 */
function NotificationDetails({
    allowPreferredEmail,
    goToProfileDetails, 
    profile, 
    setValue,
    textMessagingEnabled,
    weekendReminderEmailSettingEnabled
}) {
    return (
        <div className={css['header-block']}>
            <h1>Notifications</h1>
            <hr className={css['divider']} />
            <div className={css['content-block']}>
                <p>Customize notifications of reminders and updates of {getWord('Starfish')} Activity below.<b> Be sure to verify your profile contact information is accurate.</b></p>
                { textMessagingEnabled &&
                    <TextPreferences cellPhone={profile.cellPhone}
                                     goToProfileDetails={goToProfileDetails}
                                     setValue={setValue}
                                     textNotificationEnabledForUser={profile.textNotificationEnabled} />
                }
                { allowPreferredEmail &&
                    <EmailPreferences allowPreferredEmail={allowPreferredEmail}
                                      correspondenceTo={profile.correspondenceTo}
                                      goToProfileDetails={goToProfileDetails}
                                      preferredEmail={profile.preferredEmail}
                                      setValue={setValue} />
                }
                <h2>Preferences</h2>
                <p>Set preferences for text and email notifications.</p>
                <AppointmentPreferences reminderTime={profile.reminderTime}
                                        reminderWhen={profile.reminderWhen}
                                        sendAlert={profile.sendAlert}
                                        sendAlertTime={profile.sendAlertTime}
                                        sendReminder={profile.sendReminder}
                                        weekendRemindersOff={profile.weekendRemindersOff}
                                        setValue={setValue}
                                        weekendReminderEmailSettingEnabled={weekendReminderEmailSettingEnabled} />
            </div>
        </div>
    );
}

NotificationDetails.propTypes = {
    allowPreferredEmail: PropTypes.bool,
    goToProfileDetails: PropTypes.func.isRequired,
    profile: PropTypes.shape({
        cellPhone: PropTypes.string,
        correspondenceTo: PropTypes.oneOf(['BOTH_MAIL', 'SCHOOL_MAIL']),
        preferredEmail: PropTypes.string,
        reminderTime: PropTypes.string,
        reminderWhen: PropTypes.string,
        sendAlert: PropTypes.bool,
        sendAlertTime: PropTypes.number,
        sendReminder: PropTypes.bool,
        textNotificationEnabled: PropTypes.bool,
        weekendRemindersOff: PropTypes.bool
    }),
    setValue: PropTypes.func.isRequired,
    textMessagingEnabled: PropTypes.bool,
    weekendReminderEmailSettingEnabled: PropTypes.bool.isRequired
};

export default NotificationDetails;
